"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEarlyBankingClose = void 0;
const earlyBankingCloses_1 = require("../../constants/earlyBankingCloses");
const isWeekday_1 = require("../../utils/isWeekday");
const toIsoDate_1 = require("../../utils/toIsoDate");
function getEarlyBankingClose(date) {
    const standardDate = (0, toIsoDate_1.toIsoDate)(date);
    return (0, isWeekday_1.isWeekday)(standardDate) && earlyBankingCloses_1.earlyBankingCloses.hasOwnProperty(standardDate)
        ? earlyBankingCloses_1.earlyBankingCloses[standardDate]
        : 0;
}
exports.getEarlyBankingClose = getEarlyBankingClose;
//# sourceMappingURL=index.js.map